import Phaser from "phaser";
import { STORY_CONFIG } from "../story/storyConfig";
import type { WorldLifeLayers } from "./WorldLifeSystem";

export class ChampionPulseSystem {
  private graphics: Phaser.GameObjects.Graphics;
  private intensity = 0;
  private surge = 0;

  constructor(private scene: Phaser.Scene, layers: WorldLifeLayers) {
    this.graphics = scene.add.graphics();
    layers.particles.add(this.graphics);
  }

  reset() {
    this.intensity = 0;
    this.surge = 0;
    this.graphics.clear();
  }

  trigger(seconds: number = STORY_CONFIG.storyBeats.championSurgeSeconds) {
    this.surge = Math.max(this.surge, seconds);
  }

  update(dt: number, player: { x: number; y: number }, sprinting: boolean, progress: number, danger: number, elapsed: number) {
    const finalChorus = progress > 0.72 ? (progress - 0.72) / 0.28 : 0;
    const target = Phaser.Math.Clamp((sprinting ? 0.68 : 0) + finalChorus * 0.2 + danger * 0.14 + this.surge * 0.22, 0, 1);
    this.intensity = Phaser.Math.Linear(this.intensity, target, target > this.intensity ? 0.18 : 0.06);
    this.surge = Math.max(0, this.surge - dt);
    this.draw(player.x, player.y, elapsed);
    return this.intensity;
  }

  private draw(x: number, y: number, elapsed: number) {
    this.graphics.clear();
    if (!STORY_CONFIG.championPulse.enabled || this.intensity < 0.025) return;
    const cfg = STORY_CONFIG.championPulse;
    const wave = 0.5 + Math.sin(elapsed * 8.5) * 0.5;
    const alpha = cfg.maxIntensity * this.intensity * (0.55 + wave * 0.25);
    const radius = cfg.ringRadius + wave * 16;
    this.graphics.lineStyle(2, 0xdfff2f, alpha);
    this.graphics.strokeEllipse(x, y + 18, radius * 1.1, radius * 0.46);
    this.graphics.lineStyle(1, 0xffffff, alpha * 0.35);
    this.graphics.strokeEllipse(x, y + 8, radius * 0.78, radius * 0.34);
  }
}
